import { preload } from './modules/preload'
import { nav } from './modules/nav'
import { slider } from './modules/slider'
import { facts } from './modules/facts'
import { toggleItem } from './modules/toggleItem'
import { counter } from './modules/counter'
import { lightbox } from './modules/lightbox'
import { openFilter } from './modules/openFilter'
import { onScroll } from './modules/onScroll'
import { dialog } from './modules/dialog'
import { bannerForms } from './modules/bannerForms'
import { accessibility } from './modules/accessibility'
import { iframeHeightCalc } from './modules/iframeHeightCalc'
import { devicecheck } from './modules/devicecheck'
import { popups } from './modules/popups'
import { initRecaptcha } from './modules/recaptcha'

window.onload = function () {
	slider()
	onScroll()
	preload()
	nav()
	openFilter()
	lightbox()
	counter()
	dialog()
	toggleItem()
	facts()
	bannerForms()
	accessibility()
	iframeHeightCalc()
	devicecheck()
	popups()
	initRecaptcha()
}
